import { getIsoWeek } from 'modules/shared/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import logger, { logError } from 'utils/logger';
import { getProjectsByWeek } from '../service';

export default function useEmployeeProjectList(employeeId) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const now = useMemo(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }, []);
  const currentIsoWeek = getIsoWeek(now);
  logger.log({
    message: 'currentIsoWeek',
    data: {
      currentIsoWeek,
    },
  });
  const { week: currentWeek } = currentIsoWeek;

  const fetchProjectsByWeek = useCallback(
    async (weekNo) => {
      setLoading(true);
      try {
        const data = await getProjectsByWeek(employeeId, weekNo);
        setProjects(data);
      } catch (error) {
        const notFoundMessage = 'No assigned jobs found for the week!';
        setProjects([]);
        if (error.message !== notFoundMessage) {
          toast.error(
            logError({
              message: 'Failed to fetch projects for employee',
              error,
              code: 'FETCH_PROJECTS_FOR_EMPLOYEE_FAILED',
            }),
          );
        }
        setProjects([]);
      } finally {
        setLoading(false);
      }
    },
    [employeeId],
  );

  useEffect(() => {
    fetchProjectsByWeek(currentWeek);
  }, [fetchProjectsByWeek, currentWeek]);

  return { projects, loading, fetchProjectsByWeek, setProjects };
}
